import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Box } from '@material-ui/core';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { Typography } from '@material-ui/core';
import CheckCircleOutlinedIcon from '@material-ui/icons/CheckCircleOutlined';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import UPI from './upi.png';
 import TransportPayWallet from './TransportPayWallet.svg';
 import CreditCard from './credit-card.png';
 import DebitCard from './debit-card.png';
 import NetBanking from './NetBanking.svg';
 import Reward from './rewards.png';
import { Grid } from '@material-ui/core';
const useStyles = makeStyles((theme) => ({
    successIcon: {
        color: '#00875a',
        fontSize: 16,
        marginLeft: 8
    },
    failIcon: {
        color: '#e61b1b',
        fontSize: 16,
        marginLeft: 8
    },
    icon:{
        fontSize: 24,
        marginLeft: 8,
        marginTop:8
    },
    leftStatusTxt:{
        marginLeft: 8,
    }
}));
export function PaymentPendingIcon(props) {
    return (<SvgIcon {...props}>
        <circle cx="8" cy="8" r="8" fill="#FEE6B9"/>
        <g clip-path="url(#13jw7zmo2a)">
            <path d="M3.287 5.762a.405.405 0 0 0-.006.06v.41c0 .17.106.322.265.381v.605c0 .203.16.37.362.38v3.495a.38.38 0 0 0-.362.379v.603a.412.412 0 0 0-.265.384v.402c0 .075.061.136.136.136h9.164c.075 0 .136-.06.136-.136v-.402a.412.412 0 0 0-.265-.384v-.607a.38.38 0 0 0-.362-.379V7.597a.38.38 0 0 0 .362-.379v-.605a.408.408 0 0 0 .265-.38v-.409c0-.02-.003-.04-.007-.06a.135.135 0 0 0 .11-.247l-4.759-2.5a.136.136 0 0 0-.126 0L3.176 5.514a.136.136 0 0 0 .111.247zm.53 1.087v-.21h1.568v.208l-1.568.002zm3.49.75v3.494a.38.38 0 0 0-.363.379v.578h-1.29v-.578a.38.38 0 0 0-.362-.38V7.598a.38.38 0 0 0 .362-.379V6.64h1.289v.578c0 .203.16.37.362.38h.002zm-.09-.75v-.21h1.566v.208l-1.567.002zm3.489.75v3.494a.38.38 0 0 0-.363.379v.578h-1.29v-.578a.38.38 0 0 0-.362-.38V7.598a.38.38 0 0 0 .362-.379V6.64h1.288v.578c0 .203.16.37.363.38h.002zm-.09-.75v-.21h1.566v.208l-1.567.002zm1.566 4.993v.207h-1.569v-.207h1.57zm-3.399 0v.207H7.214v-.207h1.57zM7.441 7.328h-.118a.109.109 0 0 1-.109-.109v-.098h1.568v.098c0 .06-.049.11-.11.11H7.442zm.98.272v3.491h-.844V7.6h.843zm-.98 3.763h1.232c.06 0 .109.049.109.109v.098H7.214v-.098c0-.06.05-.11.11-.11h.117zm-2.058.48v.207H3.816v-.208h1.567zm-1.567-4.62V7.12h1.567v.098c0 .06-.049.11-.109.11H3.922a.109.109 0 0 1-.106-.11v.003zm1.204.38v3.488h-.842V7.6l.842.003zm-1.204 3.871c0-.06.048-.108.108-.108h1.35c.06 0 .109.048.109.108v.099H3.816v-.099zm8.629.99v.267H3.55v-.267a.14.14 0 0 1 .14-.14h8.614a.14.14 0 0 1 .14.138v.002zm-.265-.99v.099h-1.567v-.099c0-.06.049-.108.109-.108h1.353a.109.109 0 0 1 .105.106v.002zm-1.204-.38V7.6h.843v3.491l-.843.003zm1.204-3.872c0 .06-.048.109-.108.109h-1.35a.109.109 0 0 1-.108-.109v-.101h1.567v.101zM7.998 3.288l4.046 2.127H3.952l4.046-2.127zM3.551 5.824c0-.075.061-.135.136-.135h8.622c.075 0 .136.06.136.135v.412c0 .075-.06.136-.136.136H3.687a.136.136 0 0 1-.136-.136v-.412z" fill="#FC6F08"/>
        </g>
        <defs>
            <clipPath id="13jw7zmo2a">
                <path fill="#fff" transform="translate(3 3)" d="M0 0h10v10H0z"/>
            </clipPath>
        </defs>
    </SvgIcon>);
}
export function TransferFailedIcon(props) {
    return (<SvgIcon {...props}>
        <circle cx="9" cy="9" r="9" fill="#E61B1B"/>
        <g clip-path="url(#mz105twbha)" fill="#fff">
            <path d="M13.243 13.243a6 6 0 1 1-8.485-8.485 6 6 0 0 1 8.485 8.485zm-.707-7.778a5 5 0 1 0-7.071 7.07 5 5 0 0 0 7.07-7.07z"/>
            <path d="M9.002 13a.5.5 0 0 1-.5-.5v-5a.5.5 0 1 1 1 0v5a.5.5 0 0 1-.5.5zM9.002 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1z"/>
        </g>
        <defs>
            <clipPath id="mz105twbha">
                <path fill="#fff" transform="matrix(1 0 0 -1 3 15)" d="M0 0h12v12H0z"/>
            </clipPath>
        </defs>
    </SvgIcon>);
}
export function TransferPendingIcon(props) {
    return (<SvgIcon {...props}>
        <circle cx="9" cy="9" r="9" fill="#FC6F08"/>
        <g clip-path="url(#1ojmy1mwfa)" fill="#fff">
            <path d="M14.527 9.724a.469.469 0 0 0-.557.358 5.13 5.13 0 0 1-.11.415.469.469 0 1 0 .897.277c.05-.162.093-.327.129-.492a.469.469 0 0 0-.358-.558zM11.487 13.424c-.124.07-.253.134-.383.193a.469.469 0 1 0 .386.854c.154-.07.306-.146.454-.229a.469.469 0 1 0-.457-.818zM8.532 5.25v3.556l-1.719 1.719a.469.469 0 1 0 .663.663L9.332 9.33A.469.469 0 0 0 9.47 9V5.25a.469.469 0 1 0-.937 0z"/>
            <path d="M14.531 4.008a.469.469 0 0 0-.469.469v1.301A6.014 6.014 0 0 0 9 3a5.96 5.96 0 0 0-4.243 1.757A5.96 5.96 0 0 0 3 9c0 1.603.624 3.11 1.757 4.243A5.961 5.961 0 0 0 9 15h.023c.17 0 .34-.007.508-.021a.469.469 0 0 0-.079-.934 5.145 5.145 0 0 1-.429.018H9A5.068 5.068 0 0 1 3.937 9 5.068 5.068 0 0 1 9 3.937c1.799 0 3.454.96 4.358 2.485h-1.289a.469.469 0 1 0 0 .937H13.5a1.49 1.49 0 0 0 .822-.246A1.5 1.5 0 0 0 15 5.86V4.477a.469.469 0 0 0-.469-.47z"/>
        </g>
        <defs>
            <clipPath id="1ojmy1mwfa">
                <path fill="#fff" transform="translate(3 3)" d="M0 0h12v12H0z"/>
            </clipPath>
        </defs>
    </SvgIcon>);
}
export function RefundInitiatedIcon(props) {
    return (<SvgIcon {...props}>
        <circle cx="9" cy="9" r="9" fill="#FC6F08"/>
        <g clip-path="url(#1ojmy1mwfa)" fill="#fff">
            <path d="M14.527 9.724a.469.469 0 0 0-.557.358 5.13 5.13 0 0 1-.11.415.469.469 0 1 0 .897.277c.05-.162.093-.327.129-.492a.469.469 0 0 0-.358-.558zM11.487 13.424c-.124.07-.253.134-.383.193a.469.469 0 1 0 .386.854c.154-.07.306-.146.454-.229a.469.469 0 1 0-.457-.818zM8.532 5.25v3.556l-1.719 1.719a.469.469 0 1 0 .663.663L9.332 9.33A.469.469 0 0 0 9.47 9V5.25a.469.469 0 1 0-.937 0z"/>
            <path d="M14.531 4.008a.469.469 0 0 0-.469.469v1.301A6.014 6.014 0 0 0 9 3a5.96 5.96 0 0 0-4.243 1.757A5.96 5.96 0 0 0 3 9c0 1.603.624 3.11 1.757 4.243A5.961 5.961 0 0 0 9 15h.023c.17 0 .34-.007.508-.021a.469.469 0 0 0-.079-.934 5.145 5.145 0 0 1-.429.018H9A5.068 5.068 0 0 1 3.937 9 5.068 5.068 0 0 1 9 3.937c1.799 0 3.454.96 4.358 2.485h-1.289a.469.469 0 1 0 0 .937H13.5a1.49 1.49 0 0 0 .822-.246A1.5 1.5 0 0 0 15 5.86V4.477a.469.469 0 0 0-.469-.47z"/>
        </g>
        <defs>
            <clipPath id="1ojmy1mwfa">
                <path fill="#fff" transform="translate(3 3)" d="M0 0h12v12H0z"/>
            </clipPath>
        </defs>
    </SvgIcon>);
}
const GetIcon = (props)=>{
    const classes = useStyles();
    const {type,className} = props;
    switch (type) {
        case "SUCCESS":
            return <CheckCircleIcon className={classes.successIcon} />;
        case "PENDING_AT_BROKER":
            return <PaymentPendingIcon className={classes.icon} />;
        case "PENDING":
            return <TransferPendingIcon className={classes.icon} />;
        case "FAILED":
            return <TransferFailedIcon className={classes.icon} />;
        case "USER_DROPPED":
            return <TransferFailedIcon className={classes.icon} />;
        case "REFUND_INITIATED":
            return <RefundInitiatedIcon className={classes.icon} />;
        case "REFUND_FAILED":
            return <InfoOutlinedIcon className={classes.failIcon} />;
        case "REFUNDED":
            return <CheckCircleOutlinedIcon className={classes.successIcon} />;
        default:
            return <></>
    }
}
const GetIconByPaymentTitle = (props)=>{
    const classes = useStyles();
    const {type,className} = props;
    switch (type) {
        case "Payment Successful":
            return <CheckCircleIcon className={classes.successIcon} />;
        case "Payment Pending":
            return <PaymentPendingIcon className={classes.icon} />;
        case "Transfer Pending":
            return <TransferPendingIcon className={classes.icon} />;
        case "Transfer Failed":
            return <TransferFailedIcon className={classes.icon} />;
        case "Refund Successful":
            return <RefundInitiatedIcon className={classes.icon} />;
        case "Refund Failed":
            return <InfoOutlinedIcon className={classes.failIcon} />;
        case "Refund Successful":
            return <CheckCircleOutlinedIcon className={classes.successIcon} />;
        default:
            return <></>
    }
}
const getTxt = (type)=>{switch (type) {
    case "SUCCESS":
        return "Payment Successful";
    case "PENDING_AT_BROKER":
        return 'Payment Pending';
    case "PENDING":
        return 'Transfer Pending';
    case "FAILED":
        return 'Transfer Failed';
    case "REFUND_INITIATED":
        return 'Refund Initiated';
    case "REFUND_FAILED":
        return 'Refund Failed';
    case "REFUNDED":
        return 'Refund Successful';
    default:
        return <></>
    }
}
const getPaymentMode = (type)=>{
    switch (type) {
        case "CREDIT_CARD":
            return <img src={CreditCard} width={24} height={24} />
        case "DEBIT_CARD":
            return <img src={DebitCard} width={24} height={24} />
        case "UPI":
                return <img src={UPI} width={24} height={24} />
        case "PhonePe":
            return <img src={UPI} width={24} height={24} />
        case "WALLET":
            return <img src={TransportPayWallet} width={24} height={24} />
        case "NET_BANKING":
            return <img src={NetBanking} width={24} height={24} />
        case "REWARDS":
            return <img src={Reward} width={24} height={24} />
        default:
            return <></>
    }
}
export const GetPaymentModes = (props)=>{
    const classes = useStyles();
    const {mode,modes} = props;
    return   <Grid container spacing={1}>
          {modes && modes.length>0 &&modes.map((value,key) => (
            value&&value.paymentMode?<Grid key={key} item>
                <Box>{getPaymentMode(value.paymentMode.toUpperCase())}</Box>
            </Grid>:<></>
          ))}
          {(!modes || (modes && modes.length<=0))&&mode&&<Box>{getPaymentMode(mode?mode.toUpperCase():'')}</Box>}
      </Grid>
}
export const GetPaymentStatusIconOnly = (props)=>{
    const classes = useStyles();
    const {type,statusTxt,leftStatusTxt,paymentTitle} = props;
    return <Box display={'flex'} alignItems={'center'}>
            {statusTxt&&<Typography>{getTxt(type)}</Typography>}
            {!type&&statusTxt&&paymentTitle&& <Typography className={classes.leftStatusTxt}>{paymentTitle}</Typography>}
            {type?<GetIcon type={type} />:paymentTitle?<GetIconByPaymentTitle type={paymentTitle} />:<></>}
            {leftStatusTxt&& <Typography className={classes.leftStatusTxt}>{getTxt(type)}</Typography>}
            {!type&&leftStatusTxt&&paymentTitle&& <Typography className={classes.leftStatusTxt}>{paymentTitle}</Typography>}
    </Box>  
}